export default "__VITE_ASSET__iP0Xfiq0__"